import {useEffect, useState} from 'react';

export default function useDebounce<T>(value: T, delay: number) {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timeout = setTimeout(() => void setDebouncedValue(value), delay);

        return () => void clearTimeout(timeout);
    }, [value, delay]);

    return debouncedValue;
}
